export default __webpack_public_path__ + "static/media/digital-empire-small-7@2x.8ec09a7a.png";